import React from 'react'

export default function StockInItemFooterStyle({signed_in}) {
  let stockin_item_buttons = null
  if (signed_in !== 'admin') stockin_item_buttons = { stockin_fc: (signed_in.user_access.stockin_fc) ? 'block' : 'none' }
  else stockin_item_buttons = { stockin_fc: 'block' }

  return (
    <React.Fragment>
      <style jsx="true">
      {`
        #stock-in-item-footer-container {
          display: flex;
          padding: 3px;
        }
        .translist-button-container {
          flex: 1;
          display: flex;
          justify-content: flex-end;
        }

        .notification {
          font-size: 1rem;
          color: blue'
          padding: 0 7px;
          padding-bottom: 5px;
          margin: auto 0;
        }

        /** Stockin Item Footer Button **/
        #stockin-addnew-button, #stockin-item-delete-button { display: ${stockin_item_buttons.stockin_fc} }

      `}
      </style>
    </React.Fragment>
  )
}
